<script setup lang="ts">
declare global {
  interface Window {
    _TDID?: any
  }
}

import { useTitle } from '@vueuse/core';
import { useWsStore } from '@/store/ws';
import { useCommonStore } from '@/store/common';
import { useConfigStore } from '@/store/config';
import { resizeObserver } from '@/utils/tools';
import Layout from '@/components/layout/Layout.vue';
import { useLayoutStore } from '@/store/layout';
import { usePopstate } from '@/hook/usePopstate';
import { setKeywords, setDescription } from '@/utils/tdk';
// import useVisitor from '@/hook/useVisitor';
import useLanguage from '@/hook/useLanguage';
import useForceRefresh from '@/hook/force-refresh';
import { createRTCPeerConnection } from '@/utils/rtc';
import { setCookie, getCookie } from '@/utils/cookie';
import { initTelegram } from '@/utils/telegram';
import { useTelegram } from '@/store/telegram';
import { useUserStore } from '@/store/User';
import { useRemResize } from '@/utils/remResize';
import { isClient } from '@vueuse/shared';
import { getTimeZone } from '@/utils/time';
import { initTDID } from '@/utils/deviceToken';
const route = useRoute();
const common = useCommonStore();
const configStore = useConfigStore();
const wsStore = useWsStore();
const layoutStore = useLayoutStore();
const { init: initForceRefresh, cleanup: destoryForchRefresh } = useForceRefresh();
const pageTitle = useTitle();
const tgStore = useTelegram();
const userStore: any = useUserStore();

const { t } = useI18n();
// 时区
if (isClient) {
  setCookie('tz', getTimeZone(), 24 * 1000 * 60 * 60);
}
configStore.getSupportLanguages();
configStore.getSupportLegalCurrency();

configStore.initZendesk(userStore.userinfo.userId || getCookie('d'));
useLanguage();

// if (!import.meta.env.SSR) {
//   const isUpdate = localStorage.getItem('device-update');
//   getVisitorId(!!isUpdate);
// }

const ssgContentHidden = computed(() => {
  return import.meta.env.SSR && route.meta?.ssg?.contentHidden;
});

onMounted(() => {
  initTDID();
  const openScreenLoadingDom: HTMLElement | null = window?.document?.querySelector('#open-screen-loading');
  if (openScreenLoadingDom) {
    openScreenLoadingDom.style.display = 'none';
  }

  resizeObserver((entires:any) => {
    if (entires?.[0]?.contentRect) {
      layoutStore.contentWidth = entires[0].contentRect.width;

      common.isMobile = entires[0].contentRect.width;
      if (entires[0].contentRect.width < 800) {
        document.documentElement.setAttribute('m', 'true');
      } else {
        document.documentElement.setAttribute('m', 'false');
      }
    }
  }).observe(document.body);

  // 红涨绿跌
  if (localStorage.getItem('upDownColor') === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  }

  if (!import.meta.env.SSR) {
    const popstate = usePopstate();
    popstate.stateChange((e: any) => {
      const { scroll } = e.state;
      const left = scroll?.left || 0;
      const top = scroll?.top || 0;

      document.documentElement.scrollTo(left, top);
      document.body.scrollTo(left, top);
    });
  }

  // 增加每12小时强制刷新页面
  initForceRefresh();

  // 获取 USDC 0 Free
  configStore.getUsdcFree();
});

onBeforeUnmount(() => {
  destoryForchRefresh();
}),

watchEffect(async() => {
  // 渠道标识
  if (route.query.f) {
    localStorage.setItem('f', `${route.query.f}`);
  }

  // // // 设备指纹功能
  // if (visitorData.value?.visitorId) {
  //   //
  //   setCookie('d', visitorData.value.visitorId, 24 * 1000 * 60 * 60);

  //   // 上报设备指纹
  //   const areadyReport = localStorage.getItem('device-report');
  //   if (areadyReport) {
  //     common.deviceTokenReport(visitorData.value);
  //     localStorage.removeItem('device-report');
  //   }
  // }

  if (!window.location.pathname.includes('/limit')) {
    if (!configStore.alreadyData.riskIp) {
      const riskIpHandler = (ip?:string) => {
        configStore.getRiskIP(ip).then((riskIpDisabled: boolean) => {
          if (riskIpDisabled) {
            window.location.href = '/limit';
          }
        });
      };
      createRTCPeerConnection().then((ip: any) => {
        if (ip) {
          common.rtcIp = ip;
          if (/^((?!^(10|172\.(1[6-9]|2[0-9]|3[01])|192\.168))([1-9]?\d|1\d\d|2[01]\d|22[0-3])(\.(1?\d{1,2}|2[0-4]\d|25[0-5])){2}\.(1?\d{1,2}|2[0-4]\d|25[0-5]))$/.test(ip)) {
            riskIpHandler(ip);
          }
        } else {
          riskIpHandler();
        }
      });
    }
  }

});

watch(() => layoutStore.pageTitle, (title: string) => {
  pageTitle.value = title ? `${t(title)} | Toobit` : 'Toobit';
}, { immediate: true });

watch(() => layoutStore.pageKeywords, (words: string) => {
  const defaultKeywords = 'Trade crypto made easy. Buy and sell BTC, Ether and other crypto coins. One of the best user experiences of trading crypto future contracts and perpetual swaps.';
  setKeywords(t(words || defaultKeywords));
}, { immediate: true });

watch(() => layoutStore.pageDescription, (desc: string) => {
  const defaultDescription = 'Buy & Sell Bitcoin, Ether | Cryptocurrency Exchange | Toobit';
  setDescription(t(desc || defaultDescription));
}, { immediate: true });

// 行情 提前建连 临时方案(后续考虑放入 路由beforeEach)
wsStore.createWS();

// 检测是否在MiniApp 中打开并初始化
if (!import.meta.env.SSR) {
  // 检测是否在MiniApp 中打开并初始化
  initTelegram();
  //  获取 cryptoPublicKey 并初始化 crypto
  configStore.getCryptoPublicKey();

  useRemResize();
}

</script>

<template>
  <Layout v-if="route.meta.ssg" :class="[tgStore.inMiniApp && 'in-tg-mini-app', { 'ssg-content-hidden': ssgContentHidden }]" />
  <client-only v-else>
    <Layout :class="tgStore.inMiniApp && 'in-tg-mini-app'" />
  </client-only>
</template>

<style lang="scss">
@import "element-plus/theme-chalk/dark/css-vars.css";
@import "@/assets/styles/entry";
@import "@/assets/styles/miniapp";

.ssg-content-hidden {
  display: none;
}
</style>
